import { Facts } from "lib/models/list-models";
import { ItemModel } from "lib/services/catalogical-models";

export const calculateItemsDiff = (selectedItems: ItemModel[], initialItems?: ItemModel[]) => ({
  added: selectedItems.filter((item) => !initialItems?.some((initial) => initial.taxonomyId === item.taxonomyId)),
  removed:
    initialItems?.filter((initial) => !selectedItems.some((item) => item.taxonomyId === initial.taxonomyId)) || [],
});

export const buildJobFamilyRule = (jobFamilyValue: string) => ({
  conditions: {
    all: [
      {
        fact: Facts.JOB_FAMILY,
        operator: "equal",
        value: jobFamilyValue,
      },
    ],
  },
});

export const getJobFamilyFromRule = (rule: any): string | undefined =>
  rule?.conditions?.all?.find((c: any) => c.fact === Facts.JOB_FAMILY)?.value;

export const fetchRecommendedTools = async (
  jobFamilies: string[],
  evaluateLists: (criteria: any, options: any) => Promise<any[]>,
  allJobFamilyCategory: string
): Promise<ItemModel[]> => {
  const results = await Promise.allSettled(
    jobFamilies
      .filter((jobFamily) => jobFamily !== allJobFamilyCategory)
      .map((jobFamily) => evaluateLists({ jobFamilyName: jobFamily }, { includeItemDetails: true }))
  );

  const toolsMap = new Map(
    results
      .flatMap((r) => (r.status === "fulfilled" ? r.value : []))
      .flatMap((list) => list.fullItems)
      .filter((tool) => tool?.taxonomyId)
      .map((tool) => [tool.taxonomyId, tool])
  );
  return sortToolsByWilsonRating(Array.from(toolsMap.values()));
};

export const sortToolsByWilsonRating = (tools: ItemModel[]): ItemModel[] =>
  tools.sort((a, b) => (b.feedback?.wilsonRating ?? 0) - (a.feedback?.wilsonRating ?? 0));
